import { LoadingContainer } from 'components/loadingContainer'
import { useClosestEvents } from 'hooks/user/useEvents'
import { useEventDetails } from 'hooks/user/useEvents/useEventDetails'
import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { EventType } from 'types/Event'

import { ColumnWrapper, EventBar, Title } from '../footer.style'

interface Props {
    data: EventType[] | undefined
}

export const Upcoming = ({ data }: Props) => {
    const closestEvents = useClosestEvents(data, 5)
    const { eventDetails } = useEventDetails(data)
    const navigate = useNavigate()

    const handleRedirect = useCallback(
        (showId: string) => {
            navigate(`/musor/${showId}`)
        },
        [navigate],
    )

    return (
        <ColumnWrapper>
            <Title>Közelgő műsoraink</Title>
            <LoadingContainer isLoading={false} error={null}>
                {closestEvents.map((event) => {
                    const eventDetail = eventDetails[event.event_id]
                    return (
                        <EventBar key={event.event_id} onClick={() => handleRedirect(event.show_id)}>
                            {eventDetail ? (
                                <>
                                    {eventDetail.show.name} - {eventDetail.location?.name},{' '}
                                    {new Date(eventDetail.event_date).toLocaleString('hu-HU', {
                                        year: 'numeric',
                                        month: '2-digit',
                                        day: '2-digit',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: false,
                                    })}
                                </>
                            ) : null}
                        </EventBar>
                    )
                })}
            </LoadingContainer>
        </ColumnWrapper>
    )
}
